<template>
  <section
    ref="section2"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="5"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
    >
      <figure class="flex flex-col gap-10 lg:w-full lg:gap-11 pb-32">
        <v-error-display :validation-errors="validationErrors"></v-error-display>
        <form method="POST" :action="routes.submitForm" id="select-broker-step-form">
            <v-csrf-token></v-csrf-token>
            <figure class="mx-auto max-w-xl flex flex-col gap-8" v-if="prerequisitesMet('agent')">
                <figure class="flex gap-3">
                    <div><v-icon icon="size" size="8"></v-icon></div>
                    <div class="flex flex-col gap-3">
                        <div class="text-heading-3-desktop">
                            Izberite kontaktno osebo
                        </div>
                        <div class="text-body-regular text-black-40">
                            Izberete kateri posrednik iz vaše agencije bo prikazan, kot
                            kontaktna oseba na oglasu. Izberete lahko samo enega
                            posrednika.
                        </div>
                    </div>
                </figure>
                <figure class="ml-auto mr-auto flex w-full flex-col gap-8">
                    <v-form-input
                        id="contactBroker"
                        label="Iščite po imenu posrednika"
                        type="text"
                        :value="contactBroker"
                        v-model="contactBroker"
                        ></v-form-input>
                    <ul class="flex flex-col gap-[10px]">
                        <li class="w-full" v-for="(broker, index) in stepData.available_brokers" v-bind:key="'broker-'+index">
                            <div :class="['radio group flex items-center', (validationErrors.broker_id ? 'has-errors' : '')]">
                                <input
                                    :id="broker.name"
                                    type="radio"
                                    :value="broker.on_office_id"
                                    name="broker_id"
                                    class="hidden"
                                    v-model="brokerId"
                                />
                                <label
                                    :for="broker.name"
                                    class="w-full text-body-medium-button"
                                >
                                    <div class="label">{{ broker.name }}</div>
                                    <div class="icon">
                                        <v-icon icon="radio-unchecked" class="unchecked"></v-icon>
                                        <v-icon icon="radio-checked" class="checked"></v-icon>
                                    </div>
                                </label>
                            </div>
                        </li>
                    </ul>
                </figure>
            </figure>
            <v-separator classes="max-w-2xl mx-auto" v-if="prerequisitesMet('agent')"/>
            <figure class="mx-auto max-w-xl flex flex-col gap-8">
                <figure class="flex gap-3">
                    <div><v-icon icon="add-to-photos" size="8"></v-icon></div>
                    <div class="flex flex-col gap-3">
                        <div class="text-heading-3-desktop">
                            Kateri kontaktni podatki želite da so vidni na oglasu?
                        </div>
                        <div class="text-body-regular text-black-40">
                            Izberite kako želite, da vas iskalci kontaktirajo. Izberete lahko več možnosti
                        </div>
                    </div>
                </figure>
                <figure class="ml-auto mr-auto flex w-full flex-col gap-8">
                    <ul class="flex flex-col gap-4">
                        <li
                            class="col-span-4"
                        >
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                checkbox-position="right"
                                label="<span class='text-black-78 text-heading-4-medium'>Telefonska številka</span>"
                                :description="stepData.user_phone_number"
                                :iconSize="6"
                                icon="phone"
                                name="show_phone_number"
                                value="1"
                                :checked="stepData.show_phone_number ?? false"
                            ></v-checkbox>
                        </li>
                        <li
                            class="col-span-4"
                        >
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                label="<span class='text-black-78 text-heading-4-medium'>Elektronski naslov</span>"
                                :description="stepData.user_email"
                                :iconSize="6"
                                icon="envelope"
                                checkbox-position="right"
                                name="show_email"
                                value="1"
                                :checked="stepData.show_email ?? false"
                            ></v-checkbox>
                        </li>
                    </ul>
                </figure>
            </figure>
            <v-separator classes="max-w-2xl mx-auto" v-if="stepData.showPlans"/>
            <figure class="mx-auto max-w-xl flex flex-col gap-8" v-if="stepData.showPlans">
                <figure class="flex gap-3">
                    <div><v-icon icon="check-circle" size="8"></v-icon></div>
                    <div class="flex flex-col gap-3">
                        <div class="text-heading-3-desktop">
                            Sprejmite pogoje
                        </div>
                        <div class="text-body-regular text-black-40">
                            V kolikor se ne strinjate, ne morete objaviti oglasov na portalu N24.
                        </div>
                    </div>
                </figure>
                <figure class="ml-auto mr-auto flex w-full flex-col gap-8">
                    <ul class="flex flex-col gap-4">
                        <li
                            class="col-span-4"
                        >
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                checkbox-position="right"
                                label="<span class='text-black-78'>Strinjam se s pogodbo o oglaševanju</span>"
                                name="marketing_contract_consent"
                                value="1"
                                :checked="marketingContractConsent"
                                @vchanged="marketingContractConsent = !marketingContractConsent"
                            ></v-checkbox>
                            <!-- description="<a href='#' class='underline'>Pogodba o oglaševanju</a>" TO GRE V ZGORNJI CHECKBOX-->
                        </li>
                        <li
                            class="col-span-4"
                        >
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                checkbox-position="right"
                                label="<span class='text-black-78'>Odstopam od pravice do odstopa od pogodbe</span>"
                                name="waive_right_to_withdraw"
                                :checked="waiveRightToWithdraw"
                                @vchanged="waiveRightToWithdraw = !waiveRightToWithdraw"
                                value="1"
                            ></v-checkbox>
                        </li>
                    </ul>
                </figure>
            </figure>
            <v-separator classes="max-w-2xl mx-auto" v-if="stepData.showPlans"/>
            <figure class="mx-auto flex flex-col gap-8 lg:w-full" v-if="stepData.showPlans">
                <figure class="flex gap-3 mx-auto max-w-xl w-full">
                    <div><v-icon icon="house-check" size="8"></v-icon></div>
                    <div class="flex flex-col gap-3">
                        <div class="text-heading-3-desktop">
                            Izberite trajanje oglasa
                        </div>
                        <div class="text-body-regular text-black-40">
                            Izberite koliko časa bi radi, da je vaš oglas aktiven.
                        </div>
                    </div>
                </figure>
                <figure class="flex flex-wrap justify-center gap-x-8 gap-y-6 mt-12 max-w-6xl mx-auto w-full" id="plans">
                    <div class="p-4 rounded-xl relative flex flex-col w-full md:w-auto md:min-w-[250px] max-w-[250px] cursor-pointer" @click="selectSubscription('90-free')"
                        :class="{
                            'bg-white shadow--big-blur': selected !== '90-free',
                            'bg-[#ECF2F1] shadow-inner': selected === '90-free'
                        }"
                    >
                        <div class="bg-green-25 rounded-lg relative overflow-hidden">
                            <div class="absolute left-4 top-4 bg-green rounded-md px-3 py-2 text-heading-4-bold z-10 text-white shadow--big-blur leading-none">
                                Brezplačno
                            </div>
                            <div class="w-full">
                                <img src="/assets/images/pricing-plans/free-plan-card.svg" alt="">
                            </div>
                        </div>
                        <div class="p-2 mt-2 flex flex-col gap-3 grow">
                            <p class="text-black-78 text-heading-4-bold">Objava oglasa je brezplačna</p>
                            <div class="grow"></div>
                            <div class="flex justify-between items-center">
                                <p class="text-green text-heading-3-desktop">0,00 €</p>
                            </div>
                        </div>
                    </div>
                    <template v-for="(plan) in stepData.plans">
                        <div class="p-4 rounded-xl relative flex flex-col w-auto md:min-w-[250px] max-w-[250px] cursor-pointer" @click="selectSubscription(plan.onOfficeProductId)"
                            :class="{
                                'bg-white shadow--big-blur': selected !== plan.onOfficeProductId,
                                'bg-[#ECF2F1] shadow-inner': selected === plan.onOfficeProductId
                            }"
                        >
                            <div class="absolute -right-2 top-[-16px] z-20" v-if="plan.popularBadge === true">
                                <div
                                    class=" bg-green-50 text-small-text-medium text-white flex items-center gap-2 shadow--big-blur rounded-full px-4 py-2">
                                    <v-icon icon="fire" class="h-5 w-5" />
                                    <span>Največkrat izbrano</span>
                                </div>
                            </div>
                            <div class="bg-green-25 rounded-lg relative overflow-hidden">
                                <div class="absolute left-4 top-4 bg-green rounded-md px-3 py-2 text-heading-4-bold z-10 text-white shadow--big-blur leading-none">
                                    {{ plan.days }} dni
                                </div>
                                <div class="w-full">
                                    <img src="/assets/images/pricing-plans/immoscout-plan-card.svg" alt="">
                                </div>
                            </div>
                            <div class="p-2 mt-2 flex flex-col gap-3 grow">
                                <p class="text-black-78 text-heading-4-bold">{{ plan.name }}</p>
                                <div class="grow"></div>
                                <div class="flex justify-between items-center">
                                    <p class="text-green text-heading-3-desktop">{{ $globalFunctions.formatPrice(plan.price) }} <span class="text-green-50">€</span></p>
                                    <div class="flex flex-col text-end">
                                        <p class="text-[#BFBFBF] text-small-text-medium">{{ $globalFunctions.formatPrice(plan.price / (plan.days / 30.0)) }} €/mesec</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </figure>
            </figure>
            <v-separator classes="max-w-2xl mx-auto" v-if="stepData.showPlans"/>
            <figure class="mx-auto max-w-xl flex flex-col gap-8" v-if="stepData.showPlans">
                <div class="flex flex-col gap-3">
                    <div class="text-body-regular text-black-40">
                        Oglas lahko shranite med osnutke, kjer ga lahko kasneje objavite.
                        Osnutki se nahajajo na vašem profilu pod zavihkom “Moji oglasi”.
                    </div>
                </div>
                <div class="flex justify-center">
                    <a
                        @click.prevent="saveAsDraft()"
                        class="button button--md h-[48px] w-[240px] px-6 button button--gray"
                    >
                        <label class="text-small-text-medium">Shranite kot osnutek</label>
                        <v-icon icon="draft" size="4"></v-icon>
                    </a>
                </div>
            </figure>
            <input type="hidden" name="subscription_type" v-model="selected" v-if="stepData.showPlans">
        </form>
      </figure>
      <v-set-phone :show="showPhoneModal" :phone-codes="stepData.phoneCodes" @close="showPhoneModal = false" @confirmed="phoneConfirmed" :send-sms-route="stepData.sendSmsRoute" :process-sms-route="stepData.processSmsRoute"/>
    </main>
    <v-add-listing-foot>
        <a
            :href="routes.previousStep ? routes.previousStep : '/'"
            class="button button--white button--md h-[48px] w-[240px] px-6 mr-4"
        >
            <v-icon icon="arrow-right" class="rotate-180" size="4"></v-icon>
            <label class="text-small-text-medium">Nazaj</label>
        </a>
      <a
        @click="submitForm('select-broker-step-form')"
        :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
      >
        <label class="text-small-text-medium">Objavite oglas</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';
import SectionSeparator from "../SectionSeparator.vue";
import SetPhoneLightBox from '../../Common/SetPhoneLightBox.vue';
import ErrorDisplay from '../ErrorDisplay.vue';

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
        "v-separator": SectionSeparator,
        "v-set-phone": SetPhoneLightBox,
        "v-error-display": ErrorDisplay
    },
    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {
            contactBroker: null,
            brokerId: null,
            selected: '',
            loading: false,
            userHasPhoneNumber: false,
            showPhoneModal: false,
            marketingContractConsent: false,
            waiveRightToWithdraw: false,
        };
    },
    mounted() {
        this.brokerId = this.stepData.broker_id
        this.userHasPhoneNumber = this.stepData.userHasPhone;
    },
    methods: {
        phoneConfirmed() {
            this.showPhoneModal = false;
            this.userHasPhoneNumber = true;
            if (this.validated) {
                this.submitForm('select-broker-step-form');
            }
        },
        saveAsDraft() {
            this.selected = 'draft';
            // We use timeout so that the selection gets updated
            setTimeout(function () {
                document.getElementById('select-broker-step-form').submit();
            }, 10);
        },
        submitForm(formId) {
            if(!this.validated) {
                return;
            }

            if (!this.userHasPhoneNumber) {
                this.showPhoneModal = true;
                return;
            }

            document.getElementById(formId).submit();
        },
        prerequisitesMet(section)
        {
            if (section == 'agent') {
                return this.stepData.show_brokers;
            }
            return true;
        },
        selectSubscription(subscription) {
            this.selected = subscription;
        },
    },
    computed: {
        validated() {
            if(this.stepData.show_brokers && !this.brokerId) {
                return false
            }

            if (this.stepData.showPlans && (!this.marketingContractConsent || !this.waiveRightToWithdraw)) {
                return false;
            }

            if (this.stepData.showPlans && !this.selected) {
                return false;
            }

            return true;
        }
    }
};
</script>
